const E2E_PREFIX = 'purchase-order-bulk-import';

export default E2E_PREFIX;
